/**
 * «پرتکرار» — بردنِ گزینه‌هایی که کاربر معمولاً همان‌ها را می‌زند به بالای فهرست.
 *
 * قاعدهٔ کاربر: کسی که برای یک عملیات **بیش از دو بار** در همان سال انتخاب شده
 * باید بالای فهرست بیاید، «که بدونیم قبلاً این کار رو این شخص انجام داده».
 *
 * دو تصمیمِ عمدی:
 *  ۱. هیچ گزینه‌ای **حذف نمی‌شود** — فقط ترتیب عوض می‌شود. این مرزِ بینِ
 *     «کمک‌کردن» و «تصمیم‌گرفتن به‌جای کاربر» است؛ اگر نفرِ لازم در فهرست
 *     نباشد، کاربر گیر می‌کند و به کلِ قابلیت بی‌اعتماد می‌شود.
 *  ۲. متنِ جست‌وجو دست‌نخورده می‌ماند. antd داخلِ گروه‌ها هم روی `label` فیلتر
 *     می‌کند، پس تایپ‌کردن مثلِ قبل کار می‌کند و پرتکرارها فقط جلو می‌افتند.
 */

export const FREQUENT_GROUP = "پرتکرار";
export const OTHERS_GROUP = "بقیهٔ فهرست";

/**
 * @param {Array} options            [{value, label, …}] — فهرستِ کامل
 * @param {Array|Map} frequent       آرایهٔ value یا Map(value → تعدادِ دفعات)
 * @param {object} opts              { showCount, othersLabel, frequentLabel }
 * @returns {Array} گزینه‌های گروه‌بندی‌شده برای antd Select
 */
export function withFrequentFirst(options, frequent, opts = {}) {
  const list = Array.isArray(options) ? options : [];
  if (!list.length) return list;

  const counts = frequent instanceof Map
    ? frequent
    : new Map((frequent || []).map((v) => [v, null]));
  if (!counts.size) return list;

  const top = [];
  const rest = [];
  list.forEach((o) => (counts.has(o.value) ? top.push(o) : rest.push(o)));
  // هیچ‌کدام پرتکرار نبود ⇒ گروه‌بندی فقط شلوغی است
  if (!top.length) return list;

  // پرتکرارترین اول؛ بدونِ شمارش، ترتیبِ اصلی حفظ می‌شود
  top.sort((a, b) => (counts.get(b.value) || 0) - (counts.get(a.value) || 0));

  const decorate = (o) => {
    const n = counts.get(o.value);
    if (!opts.showCount || !n) return o;
    return {
      ...o,
      // `label` دست‌نخورده می‌ماند تا جست‌وجو و متنِ انتخاب‌شده عوض نشود؛
      // شمارش فقط داخلِ دراپ‌داون دیده می‌شود.
      gxCount: n,
    };
  };

  return [
    { label: `${opts.frequentLabel || FREQUENT_GROUP} (${top.length})`,
      options: top.map(decorate) },
    { label: opts.othersLabel || OTHERS_GROUP, options: rest },
  ];
}

/** Map(value → count) از خروجیِ اندپوینتِ پرتکرار برای یک عملیات */
export function countsFor(byOperation, catalogId) {
  const rows = (byOperation || {})[catalogId] || (byOperation || {})[String(catalogId)];
  if (!rows || !rows.length) return null;
  return new Map(rows.map((r) => [r.employee_id, r.count]));
}
